module.exports = __webpack_public_path__ + "static/c6-4541a2572c8ca4835bd55edda76316ff.png";